<template>
    <div>
        <table id="TrialRoleTable" class="table" style="width:100%" />
        <general-dialog :dialog.sync="editRoleDialog" :header="dialogHeader">
            <template #content>
                <v-layout wrap>
                    <v-flex xs12 md12>
                        <v-text-field
                            v-model="RoleName"
                            v-validate="'required'"
                            label="Name"

                            required
                            :error-messages="errors.collect('Name')"
                            data-vv-name="Name"
                        />
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field
                            v-model="RoleDescription"
                            label="Description"
                        />
                    </v-flex>
                </v-layout>
                <RoleTreeNode ref="permission-tree" :options="finalList" :selected-keys="selectedPermissions" :all-child-nodes="allChildNodes" />
            </template>
            <template #action>
                <v-btn color="agrinome_primary" dark @click="EditPermission()">Save</v-btn>
            </template>
        </general-dialog>
    </div>
</template>

<script>
import RoleTreeNode from "@/components/UMS/TrialManagement/RoleTreeNode";
import SaveConfirmation from "@/smallComponents/Dialog/DialogContent/SaveConfirmation";

export default {
    name: "TrialRoleTable",
    components: { RoleTreeNode },

    data () {
        return {
            title: "Trial Role",
            TableName: "#TrialRoleTable", 
            APIName: "TrialRole",

            permissions: [],
            selectedPermissions: [],
            finalList: [],

            RoleName: null,
            RoleDescription: null,

            allChildNodes: null,

            SelectedId: null,

            editRoleDialog: false,
            dialogHeader: "Edit Trial Role",
        };
    },
    mounted() {
        this.drawTable();
  	this.getPermission();
    },
    methods: {
  	drawTable() {
            var self = this;
  		$("#TrialRoleTable").DataTable(dataTableOption({
  			"ajax": {
  				"url": "TrialRole/GetAll",
  			},
                "order": [[ 4, "desc" ]],
  			"columnDefs": [
  				{ targets: "_all", defaultContent: "-" },
  			],
                "columns": [
		   	{ data: "id", title: "ID" },//for checkboxes purpose
                    { data: "name", title: "Name" },
                    { data: "description", title: "Description" },
                    { data: "permissions", title: "Permissions", render: function(permission) {
                        var permissionArr = JSON.stringify(self.getTreeArr(permission));
                        return `<div class="jstree" data-permission='${permissionArr}'></div>`;
                    } },
                    { data: "creationTime", title: "Created At", render: function(date) { return self.formatCreationTime(date); } },
                    { data: "null", title: "Action", "orderable": false, render: function( data, type, row ) {
                        if (row.isStatic == false) {
                            return `
            <div class='tableRoleEdit inline-block' data-passingID=` + row.id + `><div class='round-btn grey-text'><i class='fas fa-edit'></i></div></div>
            <div class='tableActionDelete inline-block' data-passingID=` + row.id + "><div class='round-btn grey-text'><i class='fas fa-trash-alt'></i></div></div>";
                        }
                        else {
                            return "-";
                        }
                    } },
  			],
                "select": {
                    style: "single"
                },
                "exportTitle": "Role Table",
                "initComplete": function(settings, json) {
                    self.$nextTick(() => {
                        self.tableDrawTree();
                    });
                },
                "drawCallback": function( settings ) {
                    self.$nextTick(() => {
                        self.tableDrawTree();
                    });
                }
            }));

            this.tableRoleEdit(this.TableName, this.APIName);
            this.tableActionDelete(this.TableName, this.APIName);
        },
        tableDrawTree() {
            $(".jstree").each(function(index) {
                var permission = $(this).data().permission;
                $( this ).jstree({ 
                    "core": {
                        "data": permission,
                        "themes": {
                            "icons": false,
                            "dots": false,
                            "responsive": true,
                            "stripes": false
                        }
                    }
                });
            });
            this.realignTable();
        },
        tableRoleEdit(name, link) {
            var self = this;
            $(name + " tbody").on( "click", ".tableRoleEdit", function() {
                var id = $(this).data().passingid ;
                self.getRolePermission(id);
                self.SelectedId = id;
            });
        },
        getRolePermission(id) {
            var self = this;
            axios({
                method: "GET",
                url: "TrialRole/Get",
                cache: {
                    ignoreCache: true,
                },
                params: {
                    Id: id
                }
            })
                .then(function (response) {
                    self.editRoleDialog = true;
                    self.selectedPermissions = response.data.result.permissions.map( p => p.name );
                    self.RoleName = response.data.result.displayName;
                    self.RoleDescription = response.data.result.description;
                });
        },
        EditPermission() {
            var self = this;
            this.$validator.validateAll().then(result => {
                if (result) {
                    DialogBus.$emit("open", {
                        component: SaveConfirmation,
                        title: "Are you sure",
                        onSuccess: function onSuccess() {
                            self.comfirmUpdateRole();
                        }
                    });
                }
                self.editRoleDialog = false;
            });
        },
        comfirmUpdateRole() {
            var self = this;
            axios({
                method: "PUT",
                url: "TrialRole/Update",
                data: {
                    "id": this.SelectedId,
                    "name": this.RoleName,
                    "displayName": this.RoleName,
                    "description": this.RoleDescription,
                    "isStatic": false,
                    "grantedPermissions": this.$refs["permission-tree"].getCheckedKeys()
                }
            })
                .then(function (response) {
                    EventBus.$emit("snackBar", {
                        text: "Role Updated Succesfully",
                        snackbarColor: "green darken-2"
                    });
                    self.selectedPermissions = [];
                    self.$emit("update:comfirmFn", false);
                    self.reloadTable("#TrialRoleTable");
                });
        },
        getPermission() {
            var self = this;
            axios({
                method: "GET",
                url: "Permission/GetAllTrialPermissions",
            })
                .then(function (response) {
                    self.permissions = response.data.result.items;
                    self.permissions.map((permission,index) => {
                        permission.id = permission.name;
                        permission.label = permission.displayName;
                    });

                    var roots = []; // things without parent

                    // make them accessible by guid on this map
                    var all = {};

                    self.permissions.forEach(function(item) {
                        all[item.name] = item;
                    });

                    // connect childrens to its parent, and split roots apart
                    Object.keys(all).forEach(function (name) {
                        var item = all[name];
                        if (item.parentName === null) {
                            roots.push(item);
                        } else if (item.parentName in all) {
                            var p = all[item.parentName];
                            if (!("children" in p)) {
                                p.children = [];
                            }
                            p.children.push(item);
                        }
                    });

                    // done!
                    self.finalList = (roots);

                    self.arrangeChildPermission();
                });
        },
        getTreeArr(permission) {
            var allPermission = this.permissions.map(p => ({
                id: p.id,
                parent: p.parentName ? p.parentName : "#",
                text: p.displayName,
            }));

            var myPermissionTreeArr = []; 

            permission.forEach(my_p => {
                allPermission.forEach(p => {
                    if (my_p.name == p.id) {
                        myPermissionTreeArr.unshift(p);
                    }
                });
            });

            return myPermissionTreeArr;
        },
        arrangeChildPermission() {
            var allNodes = this.permissions.map( p => p.name );
            var allParentName = this.permissions.map( p => p.parentName );
            var uniquesParentNames = [...new Set(allParentName)];

            allNodes.forEach(node => {
                uniquesParentNames.forEach(parent => {
                    const index = allNodes.indexOf(parent);
                    if (index > -1) {
                        allNodes.splice(index, 1);
                    }
                });
            });

            this.allChildNodes = allNodes;
        }
    }
};
</script>

<style lang="css" scoped>
.roleEditDialog{
  min-height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/UMS/TrialManagement/RoleTable.vue